import apiClient from '../../helpers/service';
import { handleResponseError } from '../../helpers';

export const requestMe = async () => {
    try {
        const response = await apiClient.get(`/auth/user/me`);
        return {
            success: true,
            data: response.data
        };
    } catch (err) {
        return handleResponseError(err);
    }
};

const requestLogin = async (email, password) => {
    try {
        const response = await apiClient.post('/auth/account/sign-in/admpanel', {
            email,
            password
        });

        return {
            success: true,
            msg: 'Login redefinida com sucesso.',
            token: response.data.access_token,
            expires_in: response.data.expires_in
        };
    } catch (err) {
        return handleResponseError(err);
    }
};

const requestForgotPassword = async (email) => {
    try {
        await apiClient.put('/auth/account/forgot-password/admpanel', {
            email
        });

        return {
            success: true,
            email: email
        };
    } catch (err) {
        return handleResponseError(err);
    }
};

export { requestLogin, requestForgotPassword };
